import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { NotificationService } from '../../notification/notification.service';
import {
  SHOW_ACKNOWLEDGE,
  SHOW_ERROR,
  SHOW_INFO,
  ShowError,
  ShowInfo,
  notificationActions
} from './notification.actions';

@Injectable()
export class NotificationEffects {
  private actions$ = inject<Actions<notificationActions>>(Actions);
  private notificationService = inject(NotificationService);

  showInfo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SHOW_INFO),
        map((action: ShowInfo) => ({
          message: action.message,
          interpolateParams: action.interpolateParams
        })),
        tap(({ message, interpolateParams }) =>
          this.notificationService.showInfoToast(message, {}, interpolateParams)
        )
      ),
    { dispatch: false }
  );

  showError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SHOW_ERROR),
        map((action: ShowError) => ({
          message: action.message,
          interpolateParams: action.interpolateParams
        })),
        tap(({ message, interpolateParams }) =>
          this.notificationService.showErrorToast(
            message,
            {},
            interpolateParams
          )
        )
      ),
    { dispatch: false }
  );

  showInfoDialog$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SHOW_ACKNOWLEDGE),
        tap(action =>
          this.notificationService.showInfoModal(
            action.titleMessage,
            action.message,
            action.okButtonMessage
          )
        )
      ),
    { dispatch: false }
  );
}
